module.exports = __webpack_public_path__ + "img/luckdraw_back.acc9d3ab.png";